import { render, staticRenderFns } from "./BatchDeriveDialog.vue?vue&type=template&id=cb4596e8&scoped=true"
import script from "./BatchDeriveDialog.vue?vue&type=script&lang=js"
export * from "./BatchDeriveDialog.vue?vue&type=script&lang=js"
import style0 from "./BatchDeriveDialog.vue?vue&type=style&index=0&id=cb4596e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4596e8",
  null
  
)

export default component.exports